import angular from 'angular';

(function() {
  'use strict';
  var core = angular.module('app.kissorder');

  var DEFAULT_CELL_TEMPLATE =
    '<a class="grid-cell-link" ui-sref="app.kissorder.detail_tabs({ guid: row.entity.guid, order: row.entity })"><div class="ui-grid-cell-contents">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';

  core.constant(
    'ORDERS',
    Object.freeze({
      status: {
        defaultStatus: [
          'OK_SELLER_TO_PROCESS',
          'OK_SELLER_CONFIRMED',
          'OK_SELLER_PART_CONFIRMED',
          'OK_SELLER_REJECTED',
          'OK_BUYER_CANCELED',
          'OK_SELLER_DESPATCHED',
          'OK_SELLER_PART_DESPATCHED',
          'OK_BUYER_RECEPTED',
          'OK_BUYER_PART_RECEPTED',
          'OK_SELLER_INVOICED',
          'OK_SELLER_PART_INVOICED'
        ],
        locked: { id: 'locked', color: 'blue' },
        toProcess: { id: 'to_process', color: 'orange' },
        processed: { id: 'processed', color: 'green' },
        okProcessed: { id: 'ok_processed', color: 'green' },
        sent: { id: 'sent', color: 'green' },
        outscope: { id: 'outscope', color: 'red' }
      },
      type: {
        defaultTypes: ['ORDER'],
        order: 'ORDER'
      },
      pagination: {
        defaultPageSize: 20,
        defaultSort: [
          {
            direction: 'DESC',
            property: 'updatedDate',
            priority: 1
          }
        ]
      },
      columnDefs: [
        {
          name: 'getSellerName()',
          displayName: 'commons.seller',
          headerCellFilter: 'translate',
          cellClass: 'pointer',
          width: 360,
          cellTemplate: DEFAULT_CELL_TEMPLATE
        },
        {
          name: 'getBuyerName()',
          displayName: 'commons.company',
          headerCellFilter: 'translate',
          cellClass: 'pointer',
          width: 360,
          cellTemplate: DEFAULT_CELL_TEMPLATE
        },
        {
          name: 'creationDate',
          displayName: 'commons.creationDate',
          headerCellFilter: 'translate',
          cellClass: 'pointer',
          width: 160,
          cellFilter: "date:'short'",
          cellTemplate: DEFAULT_CELL_TEMPLATE
        },
        {
          name: 'updateDate',
          displayName: 'commons.updateDate',
          headerCellFilter: 'translate',
          cellClass: 'pointer',
          width: 160,
          cellFilter: "date:'short'",
          sort: { direction: 'desc', priority: 0 },
          cellTemplate: DEFAULT_CELL_TEMPLATE
        },
        {
          name: 'status',
          displayName: 'commons.status',
          headerCellFilter: 'translate',
          width: 100,
          enableSorting: false,
          cellClass: function(grid, row) {
            return row.entity.getStatusColor() + ' status bullet pointer';
          },
          cellTemplate:
            '<a class="grid-cell-link" ui-sref="app.kissorder.detail_tabs({ guid: row.entity.guid, order: row.entity })"><div class="ui-grid-cell-contents">{{\'kiss_order.status.\'+ COL_FIELD CUSTOM_FILTERS | lowercase | translate }}</div></a>'
        },
        {
          name: 'getOrderNumberOrContract()',
          displayName: 'kiss_order.list.order_number',
          headerCellFilter: 'translate',
          cellClass: 'pointer',
          width: 220,
          cellTemplate: DEFAULT_CELL_TEMPLATE
        },
        {
          name: 'guid',
          displayName: 'kiss_order.list.guid',
          headerCellFilter: 'translate',
          cellClass: 'pointer',
          width: '**',
          enableSorting: false,
          cellTemplate: DEFAULT_CELL_TEMPLATE
        }
      ],
      columnFieldMap: [
        {
          field: 'getSellerName()',
          property: 'buyerName'
        },
        {
          field: 'getBuyerName()',
          property: 'senderName'
        },
        {
          field: 'updateDate',
          property: 'updatedDate'
        },
        {
          field: 'getOrderNumberOrContract()',
          property: 'invoiceNumber'
        }
      ]
    })
  );
})();
